(function ( $ ) {
    $(function(){
        // Color picker
        $( '.sc-colorpick' )

            .iris({
                change: function( event, ui ) {
                    $( this ).parent().find( '.sc-colorpickpreview' ).css({ backgroundColor: ui.color.toString() });
                },
                hide: true,
                border: true
            })

            .on( 'click focus', function( event ) {
                event.stopPropagation();
                $( '.iris-picker' ).hide();
                $( this ).closest( 'td' ).find( '.iris-picker' ).show();
                $( this ).data( 'original-value', $( this ).val() );
            })

            .on( 'change', function() {
                if ( $( this ).is( '.iris-error' ) ) {
                    var original_value = $( this ).data( 'original-value' );

                    if ( original_value.match( /^\#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/ ) ) {
                        $( this ).val( $( this ).data( 'original-value' ) ).change();
                    } else {
                        $( this ).val( '' ).change();
                    }
                }
            });

        $( 'body' ).on( 'click', function() {
            $( '.iris-picker' ).hide();
        });
    });
})(jQuery);